export default __webpack_public_path__ + "static/signature-3b6a0e9b2d725638b70faa0c163fdb04.svg";